export default function checkTruthyValue(value) {
    if (!value) {
        return false;
    }
    if (Array.isArray(value) && value.length === 0) {
        return false;
    }
    if (
        typeof value === 'object' &&
        value !== null &&
        !Array.isArray(value) &&
        Object.keys(value).length === 0
    ) {
        return false;
    }
    return true;
}
